const DoubleDocumentsIcon = ({ className = "", ...props }) => {
  return (
    <svg
      width="40"
      height="44"
      viewBox="0 0 40 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <foreignObject x="-3.8293" y="-16.0812" width="60.4574" height="63.393">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(8.4px)",
            clipPath: "url(#bgblur_0_1880_106943_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="16.8"
        d="M33.1104 0.71875H19.6849C15.9754 0.71875 12.9707 1.97678 12.9707 7.43292V23.7985C12.9707 28.8334 15.9754 30.5127 19.6849 30.5127H33.1132C36.8227 30.5127 39.8274 28.8334 39.8274 23.7985V7.43292C39.8274 1.97678 36.8227 0.71875 33.1132 0.71875H33.1104Z"
        fill="white"
        fillOpacity="0.45"
      />
      <foreignObject x="-4.38961" y="5.19828" width="39.7597" height="43.0058">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(2.52px)",
            clipPath: "url(#bgblur_1_1880_106943_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="5.04"
        d="M22.9073 10.2383H8.07039C3.97093 10.2383 0.650391 11.6286 0.650391 17.6583V35.7443C0.650391 41.3086 3.97093 43.1643 8.07039 43.1643H22.9104C27.0099 43.1643 30.3304 41.3086 30.3304 35.7443V17.6583C30.3304 11.6286 27.0099 10.2383 22.9104 10.2383H22.9073Z"
        fill="url(#paint0_linear_1880_106943)"
        fillOpacity="0.15"
      />
      <path
        d="M8.07031 10.5186H22.9102C24.9381 10.5186 26.7134 10.8639 27.9805 11.9033C29.236 12.9332 30.0508 14.6936 30.0508 17.6582V35.7441C30.0508 38.4689 29.2395 40.2367 27.9746 41.3291C26.7021 42.428 24.9233 42.8848 22.9102 42.8848H8.07031C6.05717 42.8848 4.27837 42.4281 3.00586 41.3291C1.74106 40.2367 0.930664 38.4688 0.930664 35.7441V17.6582C0.930679 14.6936 1.74543 12.9332 3.00098 11.9033C4.26806 10.8641 6.04256 10.5186 8.07031 10.5186Z"
        stroke="url(#paint1_linear_1880_106943)"
        strokeOpacity="0.6"
        strokeWidth="0.56"
      />
      <foreignObject x="-2.42945" y="17.2405" width="36.1011" height="21.2612">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(4.62px)",
            clipPath: "url(#bgblur_2_1880_106943_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter2_d_1880_106943)" data-figma-bg-blur-radius="9.24">
        <path
          d="M8.20083 29.261C7.44052 29.261 6.81055 28.6311 6.81055 27.8708C6.81055 27.1104 7.44052 26.4805 8.20083 26.4805H23.0408C23.8011 26.4805 24.4311 27.1104 24.4311 27.8708C24.4311 28.6311 23.8011 29.261 23.0408 29.261H8.20083Z"
          fill="url(#paint2_linear_1880_106943)"
        />
      </g>
      <foreignObject x="-2.42945" y="11.0803" width="28.6812" height="21.2612">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(4.62px)",
            clipPath: "url(#bgblur_3_1880_106943_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter3_d_1880_106943)" data-figma-bg-blur-radius="9.24">
        <path
          d="M8.20083 23.1009C7.44052 23.1009 6.81055 22.4709 6.81055 21.7106C6.81055 20.9503 7.44052 20.3203 8.20083 20.3203H15.6208C16.3811 20.3203 17.0111 20.9503 17.0111 21.7106C17.0111 22.4709 16.3811 23.1009 15.6208 23.1009H8.20083Z"
          fill="url(#paint3_linear_1880_106943)"
        />
      </g>
      <foreignObject x="-2.56031" y="23.26" width="36.1011" height="21.2612">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(4.62px)",
            clipPath: "url(#bgblur_4_1880_106943_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter4_d_1880_106943)" data-figma-bg-blur-radius="9.24">
        <path
          d="M8.06997 35.2806C7.30966 35.2806 6.67969 34.6506 6.67969 33.8903C6.67969 33.13 7.30966 32.5 8.06997 32.5H22.91C23.6703 32.5 24.3002 33.13 24.3002 33.8903C24.3002 34.6506 23.6703 35.2806 22.91 35.2806H8.06997Z"
          fill="url(#paint4_linear_1880_106943)"
        />
      </g>
      <defs>
        <clipPath id="bgblur_0_1880_106943_clip_path" transform="translate(3.8293 16.0812)">
          <path d="M33.1104 0.71875H19.6849C15.9754 0.71875 12.9707 1.97678 12.9707 7.43292V23.7985C12.9707 28.8334 15.9754 30.5127 19.6849 30.5127H33.1132C36.8227 30.5127 39.8274 28.8334 39.8274 23.7985V7.43292C39.8274 1.97678 36.8227 0.71875 33.1132 0.71875H33.1104Z" />
        </clipPath>
        <clipPath id="bgblur_1_1880_106943_clip_path" transform="translate(4.38961 -5.19828)">
          <path d="M22.9073 10.2383H8.07039C3.97093 10.2383 0.650391 11.6286 0.650391 17.6583V35.7443C0.650391 41.3086 3.97093 43.1643 8.07039 43.1643H22.9104C27.0099 43.1643 30.3304 41.3086 30.3304 35.7443V17.6583C30.3304 11.6286 27.0099 10.2383 22.9104 10.2383H22.9073Z" />
        </clipPath>
        <filter
          id="filter2_d_1880_106943"
          x="-2.42945"
          y="17.2405"
          width="36.1011"
          height="21.2612"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.56" />
          <feGaussianBlur stdDeviation="1.96114" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.27 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1880_106943" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1880_106943" result="shape" />
        </filter>
        <clipPath id="bgblur_2_1880_106943_clip_path" transform="translate(2.42945 -17.2405)">
          <path d="M8.20083 29.261C7.44052 29.261 6.81055 28.6311 6.81055 27.8708C6.81055 27.1104 7.44052 26.4805 8.20083 26.4805H23.0408C23.8011 26.4805 24.4311 27.1104 24.4311 27.8708C24.4311 28.6311 23.8011 29.261 23.0408 29.261H8.20083Z" />
        </clipPath>
        <filter
          id="filter3_d_1880_106943"
          x="-2.42945"
          y="11.0803"
          width="28.6812"
          height="21.2612"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.56" />
          <feGaussianBlur stdDeviation="1.96114" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.27 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1880_106943" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1880_106943" result="shape" />
        </filter>
        <clipPath id="bgblur_3_1880_106943_clip_path" transform="translate(2.42945 -11.0803)">
          <path d="M8.20083 23.1009C7.44052 23.1009 6.81055 22.4709 6.81055 21.7106C6.81055 20.9503 7.44052 20.3203 8.20083 20.3203H15.6208C16.3811 20.3203 17.0111 20.9503 17.0111 21.7106C17.0111 22.4709 16.3811 23.1009 15.6208 23.1009H8.20083Z" />
        </clipPath>
        <filter
          id="filter4_d_1880_106943"
          x="-2.56031"
          y="23.26"
          width="36.1011"
          height="21.2612"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.56" />
          <feGaussianBlur stdDeviation="1.96114" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.27 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1880_106943" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1880_106943" result="shape" />
        </filter>
        <clipPath id="bgblur_4_1880_106943_clip_path" transform="translate(2.56031 -23.26)">
          <path d="M8.06997 35.2806C7.30966 35.2806 6.67969 34.6506 6.67969 33.8903C6.67969 33.13 7.30966 32.5 8.06997 32.5H22.91C23.6703 32.5 24.3002 33.13 24.3002 33.8903C24.3002 34.6506 23.6703 35.2806 22.91 35.2806H8.06997Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_1880_106943"
          x1="3.82648"
          y1="13.2761"
          x2="37.0466"
          y2="23.443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.9" />
          <stop offset="0.447036" stopColor="white" stopOpacity="0.955296" />
          <stop offset="1" stopColor="white" stopOpacity="0.9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1880_106943"
          x1="4.92168"
          y1="9.06235"
          x2="34.1339"
          y2="24.4368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.1" />
          <stop offset="0.473958" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.09" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1880_106943"
          x1="6.81055"
          y1="26.4805"
          x2="22.1503"
          y2="21.6859"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABABAB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1880_106943"
          x1="8.21055"
          y1="21.7203"
          x2="15.6836"
          y2="18.3868"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABABAB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1880_106943"
          x1="6.67969"
          y1="32.5"
          x2="22.0195"
          y2="27.7054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABABAB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DoubleDocumentsIcon;
